"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverOverrideProcessInfo = exports.serverOverrideProcessSync = exports.serverOverrideProcess = void 0;
const lodash_1 = require("lodash");
const serverOverrideProcess = (context) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports.serverOverrideProcessSync)(context);
});
exports.serverOverrideProcess = serverOverrideProcess;
const serverOverrideProcessSync = (context) => {
    const { component } = context;
    if ((0, lodash_1.isEmpty)(component.serverOverride)) {
        return;
    }
    (0, lodash_1.assign)(component, component.serverOverride || {});
};
exports.serverOverrideProcessSync = serverOverrideProcessSync;
exports.serverOverrideProcessInfo = {
    name: 'serverOverride',
    shouldProcess: () => true,
    process: exports.serverOverrideProcess,
    processSync: exports.serverOverrideProcessSync,
};
